// This will clear all performance marks for a given markName
// Then it will set a new mark under that name that can be compared to later
export const startPerformanceTimer = markName => {
  if (markName) {
    window.performance.clearMarks(markName);
    window.performance.mark(markName);
  }
};
export const endPerformanceTimer = markName => {
  if (markName) {
    const haveMarkToCheck = window.performance.getEntriesByName(markName, 'mark').length > 0;
    if (!haveMarkToCheck) return null;
    const measureResult = window.performance.measure(`measure ${markName} to now`, markName);
    window.performance.clearMarks(markName);
    window.performance.clearMeasures(`measure ${markName} to now`);
    return measureResult;
  }

  return null;
};